import React, { useState, useEffect, useContext } from 'react';
import { Box, MenuItem, Menu, ListItemIcon, ListItemText, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { InfoOutlined, /*DarkModeOutlined, LightModeOutlined,*/ LocalHotelOutlined, LanguageOutlined, EditOutlined, FullscreenOutlined, LogoutOutlined} from "@mui/icons-material";

import { ColorModeContext } from '../../context/colorMode';

import { getDisplayVersion } from '../../utils/version';

import { useNavigate } from 'react-router';

import { useDispatch } from 'react-redux';
import { setAuth } from '../../redux/infoSlice';
//import termsIcon from '../../assets/images/terms.png';
import intakehistoryOff from '../../assets/images/userDetailTab/intakeHistoryOff.png';

export const Setting = ({ appType, anchorEl, setAnchorEl }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    //const { dayNightMode, setDayNightMode } = useContext(ColorModeContext);
    const { colorMode , setColorMode } = useContext(ColorModeContext);    
    const [fullScreen, setFullScreen] = useState(false);
    // const { language, setLanguage } = useContext(LanguageContext);
    const meInfo = JSON.parse(localStorage.getItem('meInfo'));

    const type = ['setting_terms', 'privacy_title', 'privacy_third_party_title', 'privacy_marketing_title'];

    const handleClose = () => {
        setAnchorEl(false);
    };

    const handleColorModeClick = () => {
        console.log('colorMode => ', colorMode === "light" ? "dark" : "light");
        setColorMode(colorMode === "light" ? "dark" : "light");
        handleClose();
    }

    const handleDayNightModeClick = () => {
        navigate('/settings/night-mode');
        handleClose();
    }

    const handleMealMedicationRecordSettingClick = () => {
        navigate('/intakes/setting');
        handleClose();
    }

    const handleLanguageClick = () => {
        navigate('/settings/language', {state: {type: 'setting'}});
        handleClose();
    }

    const handleFullScreenClick = () => {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
              type: 'fullscreen',
              data: !fullScreen
          }));

          setFullScreen(!fullScreen);
        }        
        handleClose();
    }

    const handleEditClick = () => {
        const appType = localStorage.getItem('appType');
        navigate('/commanders/edit-slot', {state : {appType : appType}});
        handleClose();
    }

    const handleTermsClick = () => {  
      navigate('/auth/terms', {state : {appType : appType, type:type[0]}});
      handleClose();
    }

    const handlePrivacyClick = () => {  
      navigate('/auth/terms', {state : {appType : appType, type:type[1]}});
      handleClose();
    }

    const handlePrivacyThirdPartyClick = () => {  
      navigate('/auth/terms', {state : {appType : appType, type:type[2]}});
      handleClose();
    }

    const handlePrivacyMarketingClick = () => {  
      navigate('/auth/terms', {state : {appType : appType, type:type[3]}});
      handleClose();
    }

    const handleLogoutClick = () => {
        // Unsubscribe from Firebase topics
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'unsubscribeTopics'
            }));
            
            if(appType === 'commander') {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    type: 'accessToken',
                    data: null
                }));
            }
        }

        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('meInfo');
        localStorage.removeItem('userListViewStyle');
        localStorage.removeItem('userListFilterType');
        localStorage.removeItem('userListSearchName');

        localStorage.removeItem('commanderUID');
        localStorage.removeItem('commanderInfo');
        
        dispatch(setAuth({accessToken: null, refreshToken: null}));

        window.location.reload();
    }

    const menuItems = [
      // <MenuItem key="theme" sx={{marginBottom: '10px'}} onClick={handleColorModeClick}>
      //   <ListItemIcon>
      //     {colorMode === "light" ? <DarkModeOutlined /> : <LightModeOutlined />}
      //   </ListItemIcon>
      //   <ListItemText>{colorMode === "light" ? t('setting_dark_theme') : t('setting_light_theme')}</ListItemText>
      // </MenuItem>
    ];

    if (appType === 'commander' && window.ReactNativeWebView) {
      menuItems.push(
        <MenuItem key="fullscreen" sx={{marginBottom: '10px'}} onClick={handleFullScreenClick}>
          <ListItemIcon>
            <FullscreenOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('setting_fullscreen', { status: fullScreen ? t('setting_off') : t('setting_on') })}</ListItemText>
        </MenuItem>
      );
    }

    menuItems.push(
      <MenuItem key="language" sx={{marginBottom: '10px'}} onClick={handleLanguageClick}>
        <ListItemIcon>
          <LanguageOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t('setting_language_change')}</ListItemText>
      </MenuItem>
    );

    if (appType === 'admin' && meInfo?.grade < 100) {
      menuItems.push(
        <Divider key="divider1" />,
        <MenuItem key="nightMode" sx={{marginBottom: '10px'}} onClick={handleDayNightModeClick}>
          <ListItemIcon>
            <LocalHotelOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('setting_night_mode')}</ListItemText>
        </MenuItem>
      );

      menuItems.push(
        <Divider key="divider2" />,
        <MenuItem key="mealMedicationRecord" sx={{marginBottom: '10px'}} onClick={handleMealMedicationRecordSettingClick}>
          <ListItemIcon>
            <img src={intakehistoryOff} alt="mealMedicationRecord" style={{ width: '20px', height: '20px' }} />
          </ListItemIcon>
          <ListItemText>{t('meal_medication_record_setting')}</ListItemText>
        </MenuItem>
      );
    }

    if (appType === 'commander') {
      menuItems.push(
        appType === 'commander' && <Divider key="divider1" />,
        <MenuItem key="edit" sx={{marginBottom: '10px'}} onClick={handleEditClick}>
          <ListItemIcon>
            <EditOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('setting_edit')}</ListItemText>
        </MenuItem>
      );
    }   

    menuItems.push(
      <Divider key="divider3" />,
      <MenuItem key="logout" sx={{marginBottom: '10px'}} onClick={handleLogoutClick}>
        <ListItemIcon>
          <LogoutOutlined fontSize="small" />
        </ListItemIcon> 
        <ListItemText>{t('setting_logout')}</ListItemText>
      </MenuItem>
    );

    if (process.env.REACT_APP_MODE !== 'production') {
      menuItems.push(
        <Box key="uid" sx={{ backgroundColor: 'background.default', padding: '2px 16px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary" fontSize="15px" fontStyle="italic" > 
            {`${process.env.REACT_APP_MODE} service`}
          </Typography>
        </Box>
        );
    }

    if (appType === 'commander') {
      menuItems.push(
      <Box key="uid" sx={{ backgroundColor: 'background.default', padding: '2px 16px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary" fontSize="15px" fontStyle="italic" > 
          {`UID-${localStorage.getItem('commanderUID') || 'unknown'}`}
        </Typography>
      </Box>
      );
    }   

    menuItems.push(
      <Box key="version" sx={{ backgroundColor: 'background.default', padding: '2px 16px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary" fontSize="15px" fontStyle="italic" > 
          {getDisplayVersion()}
        </Typography>
      </Box>
    );
  
    return (
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            marginTop: '48px',
            minWidth: '140px',
            '& .MuiList-root': {
              paddingBottom: 0
            }
          },
        }}    
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {menuItems}
      </Menu>
    );
};
